import React from 'react';
import { Link, Theme, Typography, styled } from '@material-ui/core';

const StyledMUILink = styled(Link)<Theme>(({ theme }) => ({
  color: theme.palette.primary.main,
  fontWeight: 600,
}));

const CustomLink = ({ url, children }: { url: string; children: React.ReactNode }) => (
  <StyledMUILink href={url} underline="always" target="_blank" rel="noopener noreferrer">
    {children}
  </StyledMUILink>
);

const BackendHealthCheckErrorMessage = () => {
  return (
    <div style={{ marginTop: '2rem' }}>
      Dit zijn mogelijke redenen:
      <ol style={{ paddingLeft: '1.5rem', textAlign: 'justify' }}>
        <li style={{ marginBottom: '1rem' }}>
          <Typography>
            je <b>versie</b> van de app is <b>verouderd</b>;<br /> Na updates van ons platform kiest
            je browser de nieuwste versie van ons platform. Soms loopt dit fout.{' '}
            <CustomLink
              url={
                'https://www.lernova.be/faq/hoe-maak-ik-het-cache-geheugen-in-mijn-browser-leeg?hs_preview=PrsaESLs-86879139517'
              }
            >
              Zet deze 2 simpele stappen
            </CustomLink>{' '}
            om een update te forceren.
          </Typography>
        </li>
        <li style={{ marginBottom: '1rem' }}>
          <b>een probleem met je internetverbinding</b>;
          <br /> Test je internetverbinding (b.v. op{' '}
          <CustomLink url="https://fast.com/nl/">fast.com</CustomLink>). We adviseren een minimale
          snelheid van 10Mbps.
        </li>
        <li style={{ marginBottom: '1rem' }}>
          er is een <b>tijdelijk technisch probleem</b>;
          <br /> We tonen de status van onze app op de{' '}
          <CustomLink url={'https://www.lernova.be/statuspagina'}>statuspagina</CustomLink>. Daar
          vind je contactgegevens om eventuele niet gekende technische problemen te melden.
        </li>
        <li style={{ marginBottom: '1rem' }}>
          <b>we updaten ons platform</b>;
          <br /> Updates aan ons platform doen we ver buiten de schooluren of examenperiodes. Als
          een geplande onderbreking onvermijdelijk is, dan melden we dat op de{' '}
          <CustomLink url={'https://www.lernova.be/statuspagina'}>statuspagina</CustomLink>.
        </li>
      </ol>
    </div>
  );
};

export default BackendHealthCheckErrorMessage;
